const tokens = {};
const theme = {
    meta: {
        scope: 'all',
        parameters: {
            backgroundColor: {
                type: 'string',
            },
            borderRadius: {
                type: 'number',
            },
            borderColor: {
                type: 'string',
            },
            borderWidth: {
                type: 'number',
            },
            height: {
                type: 'number',
            },
            paddingHorizontal: {
                type: 'number',
            },
            paddingVertical: {
                type: 'number',
            },
            textMarginVertical: {
                type: 'number',
            },
            textMarginHorizontal: {
                type: 'number',
            },
            textFontSize: {
                type: 'number',
            },
            textFontWeight: {
                type: 'string',
            },
            textColor: {
                type: 'string',
            },
            iconName: {
                type: 'string',
            },
            iconColor: {
                type: 'string',
            },
            iconWidth: {
                type: 'number',
            },
            iconHeight: {
                type: 'number',
            },
            iconMarginHorizontal: {
                type: 'number',
            },
            iconMarginVertical: {
                type: 'number',
            },
            iconMarginRight: {
                type: 'number',
            },
        },
        appearances: {
            subtle: {
                default: true,
            },
            tag: {
                default: false,
            },
        },
        variantGroups: {
            status: {
                basic: {
                    default: true,
                },
                primary: {
                    default: false,
                },
                secondary: {
                    default: false,
                },
                info: {
                    default: false,
                },
                success: {
                    default: false,
                },
                warning: {
                    default: false,
                },
                danger: {
                    default: false,
                },
            },
            size: {
                xs: {
                    default: false,
                },
                sm: {
                    default: true,
                },
                md: {
                    default: false,
                },
                lg: {
                    default: false,
                },
                xl: {
                    default: false,
                },
            },
            outline: {
                outlinenone: {
                    default: true,
                },
                outlinewarning: {
                    default: false,
                },
            },
        },
        states: {},
    },
    appearances: {
        subtle: {
            mapping: {
                iconName: 'close-circle',
                textFontWeight: 'bold',
            },
            variantGroups: {
                status: {
                    basic: {
                        backgroundColor: 'color-gray-80',
                        textColor: 'color-text-tertiary',
                        iconColor: 'color-text-tertiary',
                    },
                    primary: {
                        backgroundColor: 'color-brand2-5',
                        textColor: 'color-brand2-500',
                        iconColor: 'color-brand2-500',
                    },
                    secondary: {
                        backgroundColor: 'color-brand1-80',
                        textColor: 'color-brand1-5',
                        iconColor: 'color-brand1-5',
                    },
                    info: {
                        backgroundColor: 'color-info-10',
                        textColor: 'color-info-500',
                        iconColor: 'color-info-500',
                    },
                    success: {
                        backgroundColor: 'color-success-10',
                        textColor: 'color-success-500',
                        iconColor: 'color-success-500',
                    },
                    warning: {
                        backgroundColor: 'color-warning-10',
                        textColor: 'color-warning-500',
                        iconColor: 'color-warning-500',
                    },
                    danger: {
                        backgroundColor: 'color-danger-10',
                        textColor: 'color-danger-500',
                        iconColor: 'color-danger-500',
                    },
                },
                size: {
                    xs: {
                        height: 18,
                        textMarginHorizontal: 2,
                        textMarginVertical: 2,
                        paddingHorizontal: 2,
                        paddingVertical: 4,
                        textFontSize: 10,
                        textFontWeight: 'bold',
                        iconWidth: 14,
                        iconHeight: 14,
                        iconMarginVertical: 2,
                        // iconMarginHorizontal: 2,
                        iconMarginRight: 2,
                    },
                    sm: {
                        height: 20,
                        textMarginHorizontal: 2,
                        textMarginVertical: 2,
                        paddingHorizontal: 2,
                        paddingVertical: 4,
                        textFontSize: 12,
                        textFontWeight: 'bold',
                        iconWidth: 16,
                        iconHeight: 16,
                        iconMarginVertical: 2,
                        // iconMarginHorizontal: 2,
                        iconMarginRight: 2,
                    },
                    md: {
                        height: 22,
                        textMarginHorizontal: 2,
                        textMarginVertical: 2,
                        paddingHorizontal: 3,
                        paddingVertical: 5,
                        textFontSize: 14,
                        textFontWeight: 'bold',
                        iconWidth: 18,
                        iconHeight: 18,
                        iconMarginVertical: 2,
                        // iconMarginHorizontal: 2,
                        iconMarginRight: 2,
                    },
                    lg: {
                        height: 24,
                        textMarginHorizontal: 2,
                        textMarginVertical: 2,
                        paddingHorizontal: 4,
                        paddingVertical: 6,
                        textFontSize: 16,
                        textFontWeight: 'bold',
                        iconWidth: 20,
                        iconHeight: 20,
                        iconMarginVertical: 2,
                        // iconMarginHorizontal: 2,
                        iconMarginRight: 2,
                    },
                    xl: {
                        height: 26,
                        textMarginHorizontal: 2,
                        textMarginVertical: 2,
                        paddingHorizontal: 4,
                        paddingVertical: 6,
                        textFontSize: 18,
                        textFontWeight: 'bold',
                        iconWidth: 22,
                        iconHeight: 22,
                        iconMarginVertical: 2,
                        // iconMarginHorizontal: 2,
                        iconMarginRight: 2,
                    },
                },
                outline: {
                    outlinenone: {
                        borderWidth: 0,
                        borderColor: 'transparent',
                    },
                    outlinewarning: {
                        borderWidth: 2,
                        borderColor: 'color-warning-500',
                    },
                },
            },
        },
        tag: {
            mapping: {
                iconName: 'close-circle',
                textFontWeight: 'text-bold-font-weight',
                textMarginHorizontal: 4,
                textMarginVertical: 2,
                paddingHorizontal: 0,
                paddingVertical: 0,
            },
            variantGroups: {
                status: {
                    basic: {
                        backgroundColor: 'color-gray-300',
                        textColor: 'color-text-white',
                        iconColor: 'color-text-white',
                    },
                    primary: {
                        backgroundColor: 'color-brand2-500',
                        textColor: 'color-text-white',
                        iconColor: 'color-text-white',
                    },
                    secondary: {
                        backgroundColor: 'color-brand1-500',
                        textColor: 'color-text-white',
                        iconColor: 'color-text-white',
                    },
                    info: {
                        backgroundColor: 'color-info-500',
                        textColor: 'color-text-white',
                        iconColor: 'color-text-white',
                    },
                    success: {
                        backgroundColor: 'color-success-500',
                        textColor: 'color-text-white',
                        iconColor: 'color-text-white',
                    },
                    warning: {
                        backgroundColor: 'color-warning-500',
                        textColor: 'color-text-white',
                        iconColor: 'color-text-white',
                    },
                    danger: {
                        backgroundColor: 'color-danger-500',
                        textColor: 'color-text-white',
                        iconColor: 'color-text-white',
                    },
                },
            },
        },
    },
};
export default {
    tokens,
    theme,
};
//# sourceMappingURL=DNAChip.theme.alucio.js.map